import { render, staticRenderFns } from "./ChangeAccount.vue?vue&type=template&id=3c6f0a20&scoped=true"
import script from "./ChangeAccount.vue?vue&type=script&lang=js"
export * from "./ChangeAccount.vue?vue&type=script&lang=js"
import style0 from "./ChangeAccount.vue?vue&type=style&index=0&id=3c6f0a20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6f0a20",
  null
  
)

export default component.exports